/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2014, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 * Drag-and-Drop Manager
 */
define(['jquery', 'underscore', '../../ui/core/Class', '../dom-utils'], function ($, _, Class, utils) {
	'use strict';

	var DnDManager = null;

	DnDManager = Class.extend({

		dropTargets: null,
		currentDropTarget: null,
		init: function init() {
			this.dropTargets = [];
			this.currentDropTarget = {};

			// Add the dialog blocker as a default drop zone to swallow and ignore any drop that happens on the backdrop
			this.addDropTarget($('body')[0], '.dialogBlocker', {
				accepts: function accepts() {
					return true;
				}
			});
		},

		// Utility method that subscribes to the specified jQuery event
		// and returns removable object, that can be inserted into the 'owned' collections
		// of subscriptions
		//
		on: function on($el, types, selector, data, fn) {
			$el.on(types, selector, data, fn);
			return {
				remove: function remove() {
					$el.off(types, selector, fn);
				}
			};
		},

		/**
   * Register a drop Zone with the drag and drop manage
   *
   *
   * @param el - The drop zone element.
   * @param selector - Selector to identify the drop zone sub regions. If not specified, there will only be one region which is the drop zone element.
   * @param callbacks
   *		callbacks.accepts(dragObject)  - Called to check if the dropzone accepts the payload.
   *		callbacks.onDragStart() - Called when a drag starts
   *		callbacks.onDragEnd() - Called when a drag ends
   *		callbacks.onDragEnter(dragObject, dropNode) - Called when we enter a drop zone
   *		callbacks.onDragMove(dragObject, dropNode) - Called when we move inside a drop zone
   *		callbacks.onDragLeave(dragObject, dropNode) - Called when we leave a drop zone
   *		callbacks.onDrop(dragObject, dropNode) - Called when a drop occurs.
   * @returns {___anonymous1282_1365}
   */
		addDropTarget: function addDropTarget(el, selector, callbacks) {
			if (typeof selector !== 'string') {
				callbacks = selector;
				selector = null;
			}

			this.removeDropTarget(el);
			this.dropTargets.push({
				el: el,
				selector: selector,
				callbacks: callbacks
			});

			return {
				remove: function () {
					this.removeDropTarget(el);
				}.bind(this)
			};
		},

		/**
   * Remove a registered drop target
   * @param el
   */
		removeDropTarget: function removeDropTarget(el) {
			var target = _.find(this.dropTargets, function (t) {
				return t.el === el;
			});
			if (target) {
				this.dropTargets.splice(_.indexOf(this.dropTargets, target), 1);
			}
		},

		_isScrollDropSupported: function _isScrollDropSupported() {
			return this.currentDropTarget.target && this.currentDropTarget.target.callbacks.isScrollDropSupported ? true : false;
		},

		/**
   *
   * Check if the intention is scrolling and return the proper scrolling enabled drop zone.
   * If we are dragging outside of the view port, the intention is to auto scroll. In this case we do the following:
   * 		- if we have a drop zone, find the closest scrollable drop zone in the ancestors.
   *      - if there is no drop zone, select the last scrollable drop zone that was used.
   *
   * If we are dragging within the view and we have no drop zone, find the closest scrolling drop zone using the last drop target that was used.
   *  @param target
   * @param isScrollDropSupported
   * @param pos - current mouse position
   *
   * @returns the target or empty object.
   */
		_validateDropTarget: function _validateDropTarget(target, isScrollDropSupported, pos) {
			var foundTarget = target;
			if (isScrollDropSupported) {
				if (pos.x + 1 >= $(window).innerWidth() || pos.y + 1 >= $(window).height() || pos.x <= 1 || pos.y <= 1) {
					// dragging outside of the viewport.. most likely the intent is to auto scroll a drop zone
					if (foundTarget) {
						foundTarget = this._getClosestTargetWithScrollSupport(foundTarget.node);
					} else {
						foundTarget = this.lastActiveScrollableTarget;
					}
				}

				if (!foundTarget && this.currentDropTarget) {
					foundTarget = this._getClosestTargetWithScrollSupport(this.currentDropTarget.node);
				}
			}

			return foundTarget || {};
		},

		/**
   * Scan the list containing the ancestors + self and return the first drop zone that suppports scrolling.
   *
   * @param dropTargetNode - the node of the drop target where to start the search
   *
   */
		_getClosestTargetWithScrollSupport: function _getClosestTargetWithScrollSupport(dropTargetNode) {
			var parentsAndSelf = $(dropTargetNode).parents();
			parentsAndSelf.splice(0, 0, dropTargetNode);
			var target = null;
			for (var i = 0; i < parentsAndSelf.length; i++) {
				target = this._getDropTargetWithScrollSupport(parentsAndSelf[i]);
				if (target) {
					this.lastActiveScrollableTarget = target;
					break;
				}
			}

			return target;
		},

		/**
   * Find the drop zone that support scrolling where the node match the given node parameter
   *
   * @param targetNode - node to match with the drop zone node.
   *
   */
		_getDropTargetWithScrollSupport: function _getDropTargetWithScrollSupport(targetNode) {
			var foundTarget = null;

			var dropTarget = _.find(this.dropTargets, function (target) {
				var $elements = $(target.el);
				if (target.selector) {
					$elements = $elements.find(target.selector);
				}

				return _.find($elements, function (node) {
					return node === targetNode && target.callbacks.isScrollDropSupported && (!target.callbacks.accepts || target.callbacks.accepts(this.dragObject));
				}.bind(this));
			}.bind(this));

			if (dropTarget) {
				foundTarget = {
					target: dropTarget,
					node: targetNode
				};
			}
			return foundTarget;
		},

		/**
   * Helper method that gets the current drop target from a position
   * @param pos
   * @param options -- options passed by the called when the startDrag method is called
   * @returns {Object} - drop target
   */
		getDropTargetFromPos: function getDropTargetFromPos(pos, options) {
			var isScrollDropSupported = options && !options.disableScrollableDropZoneSupport;

			var foundTarget = null;
			var foundTargetArea = 0;
			var foundTargetPriority = 0;

			var nonActiveDropZones = [];

			_.each(this.dropTargets, function (target) {
				var $elements = $(target.el);
				if (target.selector) {
					$elements = $elements.find(target.selector);
				}

				_.each($elements, function (node) {

					var info = this.getTargetMatchInformation(pos, node, target, foundTarget, foundTargetArea, foundTargetPriority);
					if (info.isMatch) {
						if (!target.callbacks.accepts || target.callbacks.accepts(this.dragObject)) {
							foundTarget = {
								target: target,
								node: node
							};
							foundTargetArea = info.area;
							foundTargetPriority = info.priority;
						} else if (target.callbacks.receiveEventsWhenNotAccepting) {
							nonActiveDropZones.push({
								target: target,
								node: node
							});
						}
					}
				}.bind(this));
			}.bind(this));

			foundTarget = this._validateDropTarget(foundTarget, isScrollDropSupported, pos);

			if (foundTarget) {
				foundTarget.nonActiveDropZones = nonActiveDropZones;
			}

			return foundTarget || {};
		},

		/**
   * Return true if val is between lowerBound and (lowerBound + rangeSize).
   */
		_isInRange: function _isInRange(val, lowerBound, rangeSize) {
			return val >= lowerBound && val < lowerBound + rangeSize;
		},

		/**
   * return the priority set for target or 0.
   */
		_getPriority: function _getPriority(target) {
			var priority = target.callbacks.priority;
			if (typeof priority === 'function') {
				priority = priority();
			}
			return priority || 0;
		},

		/**
   * Helper function used by getDropTargetFromPos to decide if a drop target is found or not using the current mouse position
   */
		getTargetMatchInformation: function getTargetMatchInformation(pos, node, target, foundTarget, foundTargetArea, foundTargetPriority) {
			var matchInformation = {};
			var $el = $(node);
			var bounds = node.getBoundingClientRect();
			var isVisible = $el.is(':visible');
			if (isVisible) {
				var xInRange = this._isInRange(pos.x, bounds.left, bounds.width);
				var yInRange = this._isInRange(pos.y, bounds.top, bounds.height);

				if (xInRange && yInRange) {
					matchInformation = {
						area: bounds.width * bounds.height,
						priority: this._getPriority(target)
					};
					matchInformation.isMatch = !foundTarget || matchInformation.priority > foundTargetPriority || foundTargetArea > matchInformation.area && matchInformation.priority >= foundTargetPriority;
				}
			}

			return matchInformation;
		},

		/**
   * Helper method that gets the current drop target from a node
   * @param pos
   * @returns {Object} - drop target
   */
		getDropTargetFromNode: function getDropTargetFromNode(node) {

			var target = null;
			for (var i = 0; i < this.dropTargets.length; i++) {
				if (node === this.dropTargets[i].el) {
					target = this.dropTargets[i];
					break;
				}
			}

			return target;
		},

		dragObject: null,
		/**
   * Called to start dragging
   * @param options
   *		options.event ev - the event used to start the drag. e.g. mousedown, touchstart
   *		options.type - The type of the data being dropped.
   *		options.data - The data being dropped.
   *		options.avatar - the avatar node associated with the drag and drop operation
   *		options.avatarXOffset - the number of pixel added to the avatar left position
   *		options.avatarYOffset - the number of pixel added to the avatar top position
   *		options.restrictToXAxis - restrict moving on the x axis
   *		options.restrictToYAxis - restrict moving on the y axis
   *
   *		options.callerCallbacks
   *			callerCallback.onDragStart(event, {dragObject}) - Called when the drag is started.
   *			callerCallback.onMove(event, {dragObject, dropNode}) - Called on every move event.
   *			callerCallback.onDragDone(event, {dragObject, dropNode, isDropped}) - Called when the drag is complete, whether we droppped or not.
   *
   *		options.moveXThreshold - the number of pixel to move on the X axis before we allow the drag to start. A good example to use this is
   *			when want to enable a drag horizontally and still allow vertical scrolling/panning. In this case, we would set the moveXThreshold to something like 30.
   *			This will allow vertical scroll as long as we don't drag horizontally more that 30 pixels.
   *
   *		options.moveYThreshold - the number of pixel to move on the Y axis before we allow the drag to start.
   *
   * @param moveThreshold - distance in pixel that will activate the move and the avatar
   */
		startDrag: function startDrag(options) {
			if (this.dragObject) {
				// cannot start another drag operation until the previous one is finished
				return;
			}
			$('body').addClass('preventSelection');
			this.isDragStartCalled = false;

			this.targetMap = {};

			var isTouch = utils.isTouchEvent(options.event);
			this.dragObject = {
				type: options.type,
				data: options.data,
				avatar: options.avatar,
				isTouch: isTouch || options.event.gesture !== undefined
			};

			var eventPos = utils.getEventPos(options.event);
			this.dragObject.startPosition = {
				x: eventPos.pageX,
				y: eventPos.pageY
			};

			this.setAvatar(options.avatar, options);

			this.callerCallbacks = options.callerCallbacks ? options.callerCallbacks : {};

			var $target = $(window);
			if (isTouch) {
				$target = $(utils.getEventTarget(options.event));
			}
			this.attachedMoveHandler = this.on($target, 'mousemove touchmove', this.moveHandler.bind(this, options));
			this.attachedUpHandler = this.on($target, 'mouseup touchend touchcancel', this.upHandler.bind(this));
			if (options.event.type === 'mousedown') {
				this.attachedScrollHandler = this.on($(options.event.target), 'scroll', this.scrollHandler.bind(this));
			}

			if (options.currentDropZoneNode) {
				var target = this.getDropTargetFromNode(options.currentDropZoneNode);
				if (target) {
					this.currentDropTarget = {
						target: target,
						node: options.currentDropZoneNode
					};
				}
			}
		},

		scrollHandler: function scrollHandler() /* event */{
			// we are scrolling, do not track movement
			// cancel drag
			// IE does not fire mouseUp on scrollbar so drag move continues after releasing the mouse when it should not
			this.resetDragging();
		},

		_setAvatarPosition: function _setAvatarPosition(options) {
			if (this.avatar && this.dragObject.position) {
				if (!this.avatar.parentNode) {
					$('body').append(this.avatar);
				}

				var xOffset = options && options.avatarXOffset ? options.avatarXOffset : 1;
				var yOffset = options && options.avatarYOffset ? options.avatarYOffset : 1;
				$(this.avatar).css({
					left: this.dragObject.position.x + xOffset + 'px',
					top: this.dragObject.position.y + yOffset + 'px'
				});
			}
		},

		setAvatar: function setAvatar(avatar, options) {
			this.avatar = avatar;
			this._setAvatarPosition(options);
		},

		/**
   * Move event main handler
   * @param options - drag options
   * @param ev
   */
		moveHandler: function moveHandler(options, ev) {

			//Always prevent the default behavior on drag move to prevent chrome auto scrolling
			ev.preventDefault();

			var eventPos = utils.getEventPos(ev);
			var dx = eventPos.pageX;
			var dy = eventPos.pageY;

			this.dragObject.position = {
				x: dx,
				y: dy
			};

			if (options.restrictToXAxis) {
				this.dragObject.position.y = this.dragObject.startPosition.y;
			}

			if (options.restrictToYAxis) {
				this.dragObject.position.x = this.dragObject.startPosition.x;
			}

			if (!this.isDragStartCalled && this._isThresholdNotMet(options)) {
				return;
			}

			this._setAvatarPosition(options);
			var dropTarget = this.getDropTargetFromPos(this.dragObject.position, options);

			this._callStartDrag(ev);

			this._callMove(dropTarget, ev);

			this._processCallbacks(dropTarget);

			// Don't stop the propagation. This will interfere with hammer gestures like tap and hold.
			// If there is an active tap/hold handlers, hammer needs to know when there is a move.
		},

		_processCallbacks: function _processCallbacks(dropTarget) {

			var currentNonActiveDropZones = this.currentDropTarget.nonActiveDropZones;

			// Process the callback for the active drop zone that accepted the drop
			if (dropTarget.target !== this.currentDropTarget.target || dropTarget.node !== this.currentDropTarget.node) {
				this._dropTargetCallback(this.currentDropTarget, 'onDragLeave');
				this.currentDropTarget = dropTarget;
				this._dropTargetCallback(this.currentDropTarget, 'onDragEnter');
			} else {
				this._dropTargetCallback(this.currentDropTarget, 'onDragMove');
			}

			// Process callback for drop zone that didn't accept but chose to receive the event anyway
			this._processCallbacksForNonActiveDropzones(dropTarget.nonActiveDropZones, currentNonActiveDropZones);
		},

		_processCallbacksForNonActiveDropzones: function _processCallbacksForNonActiveDropzones(newDropZones, oldDropZones) {

			_.each(newDropZones, function (dropZone) {
				if (this._isDropZoneInArray(dropZone, oldDropZones)) {
					this._dropTargetCallback(dropZone, 'onDragMove');
				} else {
					this._dropTargetCallback(dropZone, 'onDragEnter');
				}
			}.bind(this));

			if (oldDropZones) {
				_.each(oldDropZones, function (dropZone) {
					if (!this._isDropZoneInArray(dropZone, newDropZones)) {
						this._dropTargetCallback(dropZone, 'onDragLeave');
					}
				}.bind(this));
			}

			this.currentDropTarget.nonActiveDropZones = newDropZones;
		},

		_dropTargetCallback: function _dropTargetCallback(dropTarget, callbackName) {
			if (dropTarget.target && dropTarget.target.callbacks[callbackName]) {
				dropTarget.target.callbacks[callbackName](this.dragObject, dropTarget.node);
				return true;
			}
			return false;
		},
		_isDropZoneInArray: function _isDropZoneInArray(dropZone, dropZoneArray) {
			var found = false;
			if (dropZoneArray) {
				for (var i = 0; i < dropZoneArray.length; i++) {
					if (dropZone.target === dropZoneArray[i].target) {
						found = true;
						break;
					}
				}
			}

			return found;
		},

		_isThresholdNotMet: function _isThresholdNotMet(options) {
			var hasThreshold = options.moveXThreshold || options.moveYThreshold;
			var isXThresholdNotMet = !options.moveXThreshold || options.moveXThreshold > Math.abs(this.dragObject.position.x - this.dragObject.startPosition.x);
			var isYThresholdNotMet = !options.moveYThreshold || options.moveYThreshold > Math.abs(this.dragObject.position.y - this.dragObject.startPosition.y);

			return hasThreshold && isXThresholdNotMet && isYThresholdNotMet;
		},

		_callMove: function _callMove(dropTarget, ev) {
			if (this.callerCallbacks.onMove) {
				this.callerCallbacks.onMove(ev, {
					dragObject: this.dragObject,
					dropTargetNode: dropTarget.node
				});
			}
		},

		_callStartDrag: function _callStartDrag(ev) {
			if (this.callerCallbacks.onDragStart && !this.isDragStartCalled) {
				this.callerCallbacks.onDragStart(ev, { dragObject: this.dragObject });

				_.each(this.dropTargets, function (target) {
					if (target.callbacks.onDragStart) {
						target.callbacks.onDragStart(this.dragObject);
					}
				}.bind(this));
			}
			$('body').addClass('dragging');
			this.isDragStartCalled = true;
		},

		/**
   *  mouseup/touchend main handler
   *
   * @param ev
   */
		upHandler: function upHandler(ev) {
			if (this.isDragStartCalled) {
				var isDropped = false;
				$('body').removeClass('dragging');

				var dropTarget = this.currentDropTarget;
				if (this._dropTargetCallback(dropTarget, 'onDrop')) {
					isDropped = true;
				}

				if (this.callerCallbacks.onDragDone) {
					this.callerCallbacks.onDragDone(ev, {
						dragObject: this.dragObject,
						dropTargetNode: isDropped ? dropTarget.node : null,
						isDropped: isDropped
					});
				}

				if (dropTarget.nonActiveDropZones) {
					_.each(dropTarget.nonActiveDropZones, function (dropZone) {
						this._dropTargetCallback(dropZone, 'onDrop');
					}.bind(this));
				}

				_.each(this.dropTargets, function (target) {
					if (target.callbacks.onDragEnd) {
						target.callbacks.onDragEnd(this.dragObject);
					}
				}.bind(this));
			}

			this.resetDragging();

			// Don't stop the propagation. This will interfere with hammer gestures like tap and hold.
			// If there is an active tap/hold handlers, hammer needs to know when the touch ends.
		},
		resetDragging: function resetDragging() {

			// Release the capture that we set in the mouse down.
			// This is used to allow IE to keep firing the mouse event when the mouse leaves the window or iframe
			if (document.releaseCapture) {
				document.releaseCapture();
			}

			if (this.attachedMoveHandler) {
				this.attachedMoveHandler.remove();
			}
			if (this.attachedUpHandler) {
				this.attachedUpHandler.remove();
			}

			if (this.attachedScrollHandler) {
				this.attachedScrollHandler.remove();
			}

			$('body').removeClass('preventSelection');
			this.currentDropTarget = {};
			this.dragObject = null;
			this.isDragStartCalled = false;
			this.targetMap = null;
			this.lastActiveScrollableTarget = null;

			$(this.avatar).remove();
		}
	});

	return new DnDManager();
});
//# sourceMappingURL=DnDManager.js.map



// WEBPACK FOOTER //
// ./src/js/lib/@waca/core-client/js/core-client/utils/dnd/DnDManager.js